var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.hasRating)?_c('div',[_c('div',{staticStyle:{"background":"#eee","width":"100%","border-radius":"3px","overflow":"hidden"}},[_c('div',{style:({ background: _vm.backgroundColor, width: _vm.width, height: '10px' })})])]):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }